import { render, staticRenderFns } from "./DownloadContainer.vue?vue&type=template&id=9427afc0"
import script from "./DownloadContainer.vue?vue&type=script&lang=js"
export * from "./DownloadContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9427afc0')) {
      api.createRecord('9427afc0', component.options)
    } else {
      api.reload('9427afc0', component.options)
    }
    module.hot.accept("./DownloadContainer.vue?vue&type=template&id=9427afc0", function () {
      api.rerender('9427afc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/elements/downloadoverview/assets/vue/DownloadContainer.vue"
export default component.exports